import { registerPlugin } from '@capacitor/core';
const LaunchNavigator = registerPlugin('LaunchNavigator', {
    web: () => import('./web').then((m) => new m.LaunchNavigatorWeb()),
});
export * from './definitions';
export { LaunchNavigator };
//# sourceMappingURL=index.js.map